import { PLATFORMS } from '@/data/siteData'
import { useModal } from '@/hooks/useModal'
import Modal from '@/components/Modal/Modal'
import PlatformCard from '@/components/PlatformCard/PlatformCard'
import PlatformDetail from '@/components/PlatformDetail/PlatformDetail'
import StatsBand from '@/components/StatsBand/StatsBand'
import CtaSection from '@/components/CtaSection/CtaSection'
import styles from './PlatformPage.module.css'

const platform = PLATFORMS.find(p => p.id === 'internnexus')

const WHY_INTERN = [
  { icon: '🏢', title: 'Real Company Projects', desc: 'Not simulations. Actual 4–6 week deliverables for real startups and companies.' },
  { icon: '🧑‍🏫', title: 'Expert Mentor Oversight', desc: 'Every project is supervised by a domain expert who reviews milestones and guides you.' },
  { icon: '📋', title: 'Milestone Tracking', desc: 'Structured weekly deliverables keep you accountable and build a professional work ethic.' },
  { icon: '🏆', title: 'Company-Rated Certificates', desc: 'Your completion certificate is co-signed by the company — adding real credibility to your profile.' },
  { icon: '🔗', title: 'JobNexus Pipeline', desc: 'Top performers get a direct referral to JobNexus for full-time placement opportunities.' },
  { icon: '🌐', title: 'Remote & Flexible', desc: 'Work from anywhere. Projects are fully remote with async collaboration tools.' },
]

export default function InternNexusPage() {
  const { modal, openModal, closeModal } = useModal()

  return (
    <>
      {/* ── PAGE HERO ── */}
      <section className={styles.hero} aria-label="InternNexus hero">
        <div className={styles.heroBg} style={{ background: 'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(8,145,178,0.2) 0%, transparent 70%)' }} aria-hidden="true" />
        <div className={styles.heroContent}>
          <span
            className={styles.heroBadge}
            style={{ background: platform.colorBg, border: `1px solid ${platform.colorBorder}`, color: platform.color }}
          >
            <span className={styles.badgeDot} style={{ background: platform.dotColor }} />
            Internship Platform — Live now
          </span>
          <h1 className={styles.heroTitle}>
            <span className="grad-cyan">InternNexus</span>
          </h1>
          <p className={styles.heroSub}>
            Bridge the gap between training and employment. Get matched with real
            company projects, guided by expert mentors, and earn credentials that
            actually matter to employers.
          </p>
          <div className={styles.heroActions}>
            <button className="btn btn-cyan btn-lg" onClick={() => openModal('internnexus')}>
              Explore InternNexus
            </button>
            <a href="https://in.nexusaiweb.com" target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-lg">
              Browse Internships
            </a>
          </div>
        </div>
      </section>

      {/* ── PLATFORM CARD ── */}
      <section className={styles.cardSection} aria-label="InternNexus details">
        <PlatformCard platform={platform} onOpenModal={openModal} />
      </section>

      {/* ── DEEP DIVE: overview, stats, pillars, journey, audience, FAQ ── */}
      <PlatformDetail id="internnexus" />

      {/* ── WHY INTERN ── */}
      <section className={styles.featuresSection} aria-label="Why InternNexus">
        <div className={styles.featuresInner}>
          <p className="section-label">Why InternNexus</p>
          <h2 className="section-title">Real experience. Real credentials.</h2>
          <div className={styles.featuresGrid}>
            {WHY_INTERN.map(({ icon, title, desc }) => (
              <div key={title} className={styles.featCard}>
                <div className={styles.featIcon} style={{ background: 'rgba(8,145,178,0.12)' }}>{icon}</div>
                <h3 className={styles.featTitle}>{title}</h3>
                <p className={styles.featDesc}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <StatsBand />

      {/* ── CTA ── */}
      <CtaSection
        label="Get Placed"
        title={'Real internships,\nlive now'}
        sub="Apply now and get matched with real company projects and expert mentors."
        ctaText="Browse Internships"
        ctaHref="https://in.nexusaiweb.com"
      />

      {modal && <Modal type={modal} onClose={closeModal} />}
    </>
  )
}
